"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputSubmit = useInputSubmit;
const react_1 = require("react");
function childrenHasFocus(node) {
    node.childNodes.forEach((child) => {
        if (document.activeElement === child) {
            return true;
        }
    });
    return false;
}
function submitResolver(type, node) {
    switch (type) {
        case "checkbox":
            return document.activeElement === node.firstChild;
        case "radio-group":
            return childrenHasFocus(node);
    }
}
function useInputSubmit(ref, type, disabled) {
    (0, react_1.useEffect)(() => {
        const node = ref.current;
        if (!node || disabled) {
            return;
        }
        const handleSubmit = (e) => {
            var _a;
            if (e instanceof KeyboardEvent && e.key === "Enter" && submitResolver(type, node)) {
                const closestForm = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.closest("form");
                if (closestForm) {
                    closestForm.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
                }
            }
        };
        node.addEventListener("keydown", handleSubmit);
        return () => node.removeEventListener("keydown", handleSubmit);
    }, [disabled, ref, type]);
}
